export default "__VITE_ASSET__DpzaD2pN__"